fragment ImageTitleFeatureFragment on imageTitleFeature_Entry {
  typeHandle
  heading
  imageTitleFeatures {
    ... on imageTitlefeaturesBlock_Entry {
      image {
        url
        title
      }
      alt
      heading
      page {
        uri
      }
    }
  }
}
